/** A pulsing placeholder the size of what is coming. Sized by className. */
export default function Skeleton({ className = "" }) {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={`animate-pulse rounded bg-gray-200 ${className}`}
    />
  );
}
